<template>
  <v-content>
    <v-container fluid>
      <Header :title="title" />
      <v-row no-gutters>
        <v-col cols="12">

          <v-tabs
          v-model="tabs"
          >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#viewallquizzes" @click="fetchAllOpenQuizzes()"> {{ 'Quizzes' | translate }} </v-tab>
              <v-tab href="#viewalltests" @click="fetchAllTests()"> {{ 'Tests' | translate }} </v-tab>
              <v-tab href="#viewallexams" @click="fetchAllExams()"> {{ 'Exams' | translate }} </v-tab>
              <v-tab href="#viewallexercise" @click="fetchAllExercises()"> {{ 'Exercises' | translate }} </v-tab>
          </v-tabs>

           <v-tabs-items v-model="tabs">
              <v-tab-item value="viewallquizzes">

                <div class="row" >
                  <div class="col-md-8" >
                    <template>
                      <v-card>
                          <BarChart 
                          :chart-data="chartData"
                          :height=300
                          />
                          <v-card-actions class="bar-chart-btn">
                            <v-btn class="white--text flexible-button" :color="primary_color" x-large block @click="callDailyQuiz()"> {{ "Take Daily Quiz" | translate  }}</v-btn>
                          </v-card-actions>
                      </v-card>
                    </template>
                  </div>
                  <div class="col-md-4" >
                  </div>
                </div>

                <div class="row" >
                  <div class="col-md-12" >
                    <v-card class="d-flex flex-wrap" v-if="quizzes.length"> 
                      <template>
                        <v-card
                          class="ma-4 pa-1"
                          max-width="350"
                          width="350"
                          v-for="(quiz, quizindex) of quizzes" :key="quizindex"
                          @click="callQuiz(quiz.quiz_id)"
                        >
                          <v-img
                            v-if="quiz.quiz_image"
                            :src="company_storage_url + quiz.quiz_image"
                              height="200px"
                          ></v-img>

                          <v-card-title>
                            {{quiz.quiz_name}}
                          </v-card-title>
                            <v-chip
                                class="ma-2"
                                small
                              >
                            <v-icon small left> {{(quiz.quiz_type=='course')? 'mdi-file' : ' mdi-book'}}</v-icon>
                              {{(quiz.quiz_type=='course')? quiz.course_name: quiz.module_name}}
                            </v-chip>
                        
                          <v-card-subtitle>
                            {{quiz.quiz_description}}
                          </v-card-subtitle>
                        </v-card>
                      </template>

                    </v-card>
                    <v-card v-else>
                      <v-card-text> {{'No Quizzes to show' | translate}}</v-card-text>
                    </v-card>
                  </div>
                </div>

              </v-tab-item>

              <v-tab-item value="viewalltests">
                <div class="d-flex flex-wrap"> 
                    <template v-if="allTests.length">
                        <v-card
                          class="ma-4 pa-1"
                          max-width="350"
                          width="350"
                          v-for="test of allTests" :key="test.test_id"
                          @click="callTest(test.course_id,test.module_id)"  
                        >
                          <v-img
                              v-if="test.test_image"
                              :src="storage_url + test.test_image"
                              height="200px"
                          ></v-img>
                          <v-img
                              v-else
                              alt="Test Image"
                              height="200px"
                              aspect-ratio="1"
                              class="tutor-image grey lighten-2"
                          ></v-img>

                          <v-card-title>
                            {{test.test_name}}
                          </v-card-title>
                        
                          <v-card-subtitle>
                            {{test.test_description}}
                          </v-card-subtitle>
                        </v-card>
                    </template>
                </div>
               
                  <template>
                    <v-card-title>{{"Test Results" | translate}}</v-card-title>
                    <v-simple-table class="mt-6 test-result-table">
                      <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{'Test Name' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Attempt' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Passing Percentage' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Scored Percentage' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Status' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Test Taken on' | translate}}
                            
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in allTestResults"
                          :key="item.attempt+'test'+item.test_id"
                          @click="getTestResults(item.test_id, item.attempt)"
                        >
                          <td>{{ item.test_name }}</td>
                          <td>{{ item.attempt }}</td>
                          <td>{{ item.passing_percentage }}</td>
                          <td>{{ item.scored_percentage }}</td>
                          <td>{{ item.is_passed ? 'PASSED' : 'FAILED' | translate}}</td>
                          <td>{{ convertDate(item.created_at) }}</td>
                        </tr>
                      </tbody>
                    </template>
                    </v-simple-table>
                  </template>
                       
              </v-tab-item>
              <v-tab-item value="viewallexams">

                <div class="d-flex flex-wrap"> 
                    <template v-if="allExams.length">
                        <v-card
                          class="ma-4 pa-1"
                          max-width="350"
                          width="350"
                          v-for="test of allExams" :key="test.test_id"
                          @click="callExam(test.course_id,test.module_id)"  
                        >

                        <div class="lockedoverlay">
                          <v-card-title v-if="test.show_exam ? 'text-h5' : 'text-h5 locked'" >
                            <v-icon large color="white">mdi-lock</v-icon> 
                          </v-card-title>
                          <v-card-subtitle v-if="test.show_exam ? 'text-h5' : 'locked'">{{"This exam is Locked. Complete all modules in the course, tests, exercises, events to unlock this exam."| translate}}</v-card-subtitle>

                        </div>
                        
                            <v-img
                                v-if="test.test_image"
                                :src="storage_url + test.test_image"
                                height="200px"
                            ></v-img>
                            <v-img
                                v-else
                                alt="Exam Image"
                                height="200px"
                                aspect-ratio="1"
                                class="tutor-image grey lighten-2"
                            ></v-img>

                            <v-card-title>
                              {{test.test_name}}
                            </v-card-title>
                          
                            <v-card-subtitle>
                              {{test.test_description}}
                            </v-card-subtitle>
                        </v-card>
                    </template>
                </div>
                
                <template>
                    <v-card-title>{{"Exam Results" | translate}}</v-card-title>
                    <v-simple-table class="mt-6 test-result-table">
                      <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{'Exam Name' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Attempt' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Passing Percentage' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Scored Percentage' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Status' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Exam Taken on' | translate}}
                            
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in allExamResults"
                          :key="item.attempt+'test'+item.test_id"
                          @click="getExamResults(item.test_id, item.attempt)"
                        >
                          <td>{{ item.test_name }}</td>
                          <td>{{ item.attempt }}</td>
                          <td>{{ item.passing_percentage }}</td>
                          <td>{{ item.scored_percentage }}</td>
                          <td>{{ item.is_passed ? 'PASSED' : 'FAILED' | translate}}</td>
                          <td>{{ convertDate(item.created_at) }}</td>
                        </tr>
                      </tbody>
                    </template>
                    </v-simple-table>
                  </template>

              </v-tab-item>

              <v-tab-item value="viewallexercise">
                <div class="d-flex flex-wrap"> 
                    <template v-if="allExercises.mandatory_exercises">
                        <v-card
                          class="ma-4 pa-1"
                          max-width="350"
                          width="350"
                          v-for="exercise of allExercises.mandatory_exercises" :key="exercise.exercise_id"
                          @click="callExercise(exercise.course.course_id,exercise,'mandatory')" 
                        >
                          <v-img
                              v-if="exercise.exercise_image"
                              :src="storage_url + exercise.exercise_image"
                              height="200px"
                          ></v-img>
                          <v-img
                              v-else
                              alt="Exercise Image"
                              height="200px"
                              aspect-ratio="1"
                              class="tutor-image grey lighten-2"
                          ></v-img>

                          <v-card-title>
                            {{exercise.exercise_name}}
                          </v-card-title>
                        
                          <v-card-subtitle>
                            {{exercise.exercise_description}}
                          </v-card-subtitle>
                        </v-card>
                    </template>

                    <template v-if="allExercises.training_exercises">
                        <v-card
                          class="ma-4 pa-1"
                          max-width="350"
                          width="350"
                          v-for="exercise of allExercises.training_exercises" :key="exercise.exercise_id"
                          @click="callExercise(exercise.course.course_id,exercise,'training')" 
                        >
                          <v-img
                              v-if="exercise.exercise_image"
                              :src="storage_url + exercise.exercise_image"
                              height="200px"
                          ></v-img>
                          <v-img
                              v-else
                              alt="Exercise Image"
                              height="200px"
                              aspect-ratio="1"
                              class="tutor-image grey lighten-2"
                          ></v-img>

                          <v-card-title>
                            {{exercise.exercise_name}}
                          </v-card-title>
                        
                          <v-card-subtitle>
                            {{exercise.exercise_description}}
                          </v-card-subtitle>
                        </v-card>
                    </template>
                </div>
               
                  <template>
                    <v-card-title>{{"Exercise Results (Mandatory)" | translate}}</v-card-title>
                    <v-simple-table class="mt-6 test-result-table">
                      <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{'Exercise Name' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Exercise Description' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Course' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Result' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Date of Submission' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Date of Grading' | translate}}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in allExerciseResultsMandatory"
                          :key="item.course.course_id+'test'+item.exercise_id"
                          @click="getExerciseResults(item, 'mandatory')"
                        >
                          <td>{{ item.exercise_name }}</td>
                          <td>{{ item.exercise_description }}</td>
                          <td>{{ item.course.course_name }}</td>
                          <td>{{ item.latest_with_grade ? item.latest_with_grade.grade : 'Not yet graded' | translate }}</td>
                          <td>{{ getLatestExerciseFile(item)?getLatestExerciseFile(item).created_at:'-' }}</td>
                          <td>{{ item.latest_with_grade ? item.latest_with_grade.graded_at  : '-'}}</td>
                        </tr>
                      </tbody>
                    </template>
                    </v-simple-table>
                  </template>

                  <template>
                    <v-card-title>{{"Exercise Results (Training)" | translate}}</v-card-title>
                    <v-simple-table class="mt-6 test-result-table">
                      <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            {{'Exercise Name' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Exercise Description' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Course' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Result' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Date of Submission' | translate}}
                          </th>
                          <th class="text-left">
                            {{'Date of Grading' | translate}}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in allExerciseResultsTraining"
                          :key="item.course.course_id+'test'+item.exercise_id"
                          @click="getExerciseResults(item, 'training')"
                        >
                          <td>{{ item.exercise_name }}</td>
                          <td>{{ item.exercise_description }}</td>
                          <td>{{ item.course.course_name }}</td>
                          <td>{{ item.latest_with_grade ? item.latest_with_grade.grade : 'Not yet graded' | translate }}</td>
                          <td>{{ getLatestExerciseFile(item)?getLatestExerciseFile(item).created_at:'-' }}</td>
                          <td>{{ item.latest_with_grade ? item.latest_with_grade.graded_at  : '-'}}</td>
                        </tr>
                      </tbody>
                    </template>
                    </v-simple-table>
                  </template>

              </v-tab-item>
          </v-tabs-items>

        </v-col>
      </v-row>
    </v-container>
      <v-dialog v-if="!loadingdata" v-model="moduleQuizDialog" persistent>
               <v-card v-if="questions.length > 0" class="quiz-container">
                <v-stepper v-model="stage">
                  <v-stepper-header>
                    <v-stepper-step :complete="stage > 1" step="1">
                      {{ "Instructions" | translate }}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step :complete="stage > 2" step="2">
                      {{ "Quiz" | translate }}
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="3">
                      {{ "Results" | translate }}
                    </v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
                    <v-stepper-content step="1">
                      <v-card
                        class="mx-auto"
                        max-width="800"
                        style="min-height: 400px; overflow-y: scroll"
                      >
                        <v-row class="ma-3">
                          <v-col cols="12">
                            <v-row>
                              <v-col cols="12" md="12" sm="12">
                                <v-card-title
                                  class="text-h5"
                                  v-text="moduleQuiz.quiz_name"
                                ></v-card-title>
                                <v-card-subtitle
                                  v-text="moduleQuiz.quiz_description"
                                ></v-card-subtitle>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row class="ma-3">
                          <v-col>
                            <div v-if="!is_daily_quiz">
                              <v-card-subtitle class="mb-n3">{{"Quiz Instruction 1"| translate}}</v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Quiz Instruction 2"| translate}}</v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Quiz Instruction 3"| translate}}</v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Quiz Instruction 4"| translate}}</v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Quiz Instruction 5"| translate }}<strong>{{ moduleQuiz.passing_percentage }}%</strong></v-card-subtitle>
                            </div>
                            <div v-else>
                              <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 1"| translate}}</v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 2"| translate}}</v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 3"| translate}}</v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 4"| translate}}<strong>{{ daily_quiz_question_count }}</strong></v-card-subtitle>
                              <v-card-subtitle class="mb-n3">{{"Daily Quiz Instruction 5"| translate }}<strong>{{ daily_quiz_passing_percent }}%</strong></v-card-subtitle>
                            </div>
                          </v-col>
                        </v-row>

                        <v-row class="ma-3" v-if="extquizdetaildata.length">
                          <v-col cols="12">
                            <div>
                              <v-divider></v-divider>
                              <DataTable
                                :title="extquizdetailtitle | translate"
                                :headers="extquizdetailheaders"
                                :items="extquizdetaildata"
                                :footerstatus='footerstatus'
                              />
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>

                      <v-card
                        class="mx-auto mt-2"
                        max-width="800"
                        v-bind:style="{ 'background-color': '#f7f7f7' }"
                        elevation="0"
                      >
                        <v-btn
                          class="white--text mt-n1"
                          :color="primary_color"
                          @click="startStage2"
                        >
                          {{ "Start" | translate }}</v-btn
                        >

                        <v-btn text @click="moduleQuizDialog = false">
                          {{ "Close" | translate }}
                        </v-btn>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card
                        class="mx-auto pa-5"
                        max-width="800"
                        style="min-height: 400px; overflow-y: scroll"
                      >
                        <v-form ref="form">
                          <v-row
                            class="no-gutters"
                            v-for="(question, questionindex) of questions"
                            :key="questionindex"
                          >
                            <v-col>
                                <v-card-title style="word-break: break-word">{{
                                  question.question_text
                                }}</v-card-title>
                                <v-card-subtitle>{{
                                  question.question_help_text
                                }}</v-card-subtitle>

                                <v-card-text class="pb-0"
                                  v-if="question.question_type == 'single-select'"
                                >
                                  <v-row class="no-gutters">
                                    <v-col cols="12">
                                      <v-radio-group class="mt-n4"
                                        v-model="
                                          questionAnswers[questionindex].answer_id
                                        "
                                          @change="checkifAnswered()"
                                      >
                                        <v-radio
                                          v-for="(
                                            answer, answerindex
                                          ) of question.answers"
                                          :key="answerindex"
                                          :value="answer.answer_id"
                                          :label="`${answer.answer_text}`"
                                        ></v-radio>
                                      </v-radio-group>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                                <v-card-text class="pb-0" v-else>
                                  <v-row class="no-gutters">
                                    <v-col cols="12">
                                      <v-checkbox class="mt-n4"
                                        v-model="
                                          questionAnswers[questionindex].answer_id
                                        "
                                        v-for="(
                                          answer, answerindex
                                        ) of question.answers"
                                        :key="answerindex"
                                        :value="answer.answer_id"
                                        :label="`${answer.answer_text}`"
                                        @change="checkifAnswered()"
                                      >
                                      </v-checkbox>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card>

                      <v-card
                        class="mx-auto mt-2"
                        max-width="800"
                        v-bind:style="{ 'background-color': '#f7f7f7' }"
                        elevation="0"
                      >
                        <v-btn
                          class="white--text mt-n1"
                          :color="primary_color"
                          @click="submitAnswers"
                          :disabled="!answeredAllQuestions"
                        >
                          {{ "Submit" | translate }}
                        </v-btn>

                        <v-btn
                          text
                          @click="
                            moduleQuizDialog = false;
                            stage = 1;
                          "
                        >
                          {{ "Quit" | translate }}
                        </v-btn>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-card
                        class="mx-auto"
                        max-width="800"
                        style="min-height: 400px; overflow-y: scroll"
                      >
                        <v-card
                          class="mx-auto result-box"
                          max-width="530"
                          elevation="0"
                        >
                          <v-row>
                            <v-col>
                              <div>
                                <h2 class="text-center text-uppercase">
                                  {{ "Result" | translate }}
                                </h2>
                                <v-card-text
                                  class="text-center text-uppercase"
                                  style="font-size: 20px"
                                  v-if="quizResults.is_passed"
                                >
                                  <v-icon large color="green">mdi-check-circle</v-icon> 
                                  {{ "passed" | translate }}</v-card-text
                                >
                                <v-card-text
                                  class="text-center text-uppercase"
                                  style="font-size: 20px"
                                  v-else
                                >
                                  <v-icon large color="red" class="mr-2">mdi-alert-circle-outline</v-icon> 

                                  {{ "failed" | translate }}</v-card-text
                                >
                                <v-row class="result-percentage">
                                  <v-col cols="12" md="6" sm="12">
                                    <v-card-text class="text-center">{{ "You scored" | translate }} {{ quizResults.scored_percentage }}%</v-card-text>
                                  </v-col>
                                  <v-col cols="12" md="6" sm="12">
                                    <v-card-text class="text-center">{{ "Percent of passing is" | translate }} {{ quizResults.passing_percentage }}%</v-card-text>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-card>

                      <v-card
                        class="mx-auto mt-2"
                        max-width="800"
                        v-bind:style="{ 'background-color': '#f7f7f7' }"
                        elevation="0"
                      >
                        <v-btn
                          text
                          @click="
                            moduleQuizDialog = false;
                            stage = 1;
                          "
                        >
                          {{ "Close" | translate }}
                        </v-btn>
                      </v-card>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card>
              <v-card v-else>
                <v-card-title>
                    {{'No Questions Found for Daily Quiz' | translate}}
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary darken-1"
                      text
                      @click="moduleQuizDialog = false"
                      >{{ "Close" | translate }}</v-btn
                  ></v-card-title>

                  <v-timeline
                    align-top
                    dense
                  >
                    <v-timeline-item
                      v-for="message in dailyQuizErrormessages"
                      :key="message.step"
                      color="red"
                      small
                    >
                      <div>
                        <div class="font-weight-normal">
                          <strong></strong> {{'Check' | translate}} {{ message.step }}
                        </div>
                        <div>{{ message.message | translate}}</div>
                      </div>
                    </v-timeline-item>
                  </v-timeline>
                </v-card>
               
            
      </v-dialog>

      <v-dialog v-if="testExamDialog" v-model="testExamDialog" persistent>
      <v-card v-if="testExam.test_id" class="test-container">
        <v-stepper v-model="stage">
          <v-stepper-header>
            <v-stepper-step :complete="stage > 1" step="1">
              {{ "Instructions" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stage > 2" step="2">
              {{testExam.module_id? "Test" : "Exam"| translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              {{ "Results" | translate }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
            <v-stepper-content step="1">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-row class="ma-3">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="9" sm="12">
                        <v-card-title
                          class="text-h5"
                          v-text="testExam.test_name"
                        ></v-card-title>
                        <v-card-subtitle
                          v-text="testExam.test_description"
                        ></v-card-subtitle>
                      </v-col>
                      <v-col cols="12" md="3" sm="12">
                        <v-avatar class="grey" size="125" tile>
                          <v-img
                            v-if="testExam.test_image"
                            :src="company_storage_url + testExam.test_image"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-3">
                  <v-col>
                    <div>
                      <v-card-subtitle class="mb-n3">{{"Test Instruction 1"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3"  v-if="testExam.time_limit_in_minutes">{{"Test Instruction 2"| translate}} <b>{{ testExam.time_limit_in_minutes }} {{ " Minutes" | translate}}</b></v-card-subtitle>
                      <v-card-subtitle class="mb-n3" v-else >{{"Test Instruction 6"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Test Instruction 3"| translate }}<strong>{{ testExam.passing_percentage }}%</strong></v-card-subtitle>
                      <v-card-subtitle class="mb-n3"  v-if="testExam.timeout_in_minutes">{{"Test Instruction 4"| translate}} <b>{{ testExam.timeout_in_minutes }} </b> {{ "Test Instruction 5" | translate }}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3" v-else >{{"Test Instruction 7"| translate}}</v-card-subtitle>
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="startTestStage2"
                >
                  {{ "Start" | translate }}</v-btn
                >

                <v-btn text @click="testExamDialog = false">
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto sticky-container"
                max-width="800"
                outlined
                v-if="testExam.time_limit_in_minutes"
              >
              <h1 class="timer" id="timer">{{'Start' | translate}}</h1>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto pa-5 scrollable-container"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-form ref="form">
                  <v-row
                    class="no-gutters"
                    v-for="(question, questionindex) of questions"
                    :key="questionindex"
                  >
                    <v-col>
                        <v-card-title style="word-break: break-word">{{
                          question.question_text
                        }}</v-card-title>
                        <v-card-subtitle>{{
                          question.question_help_text
                        }}</v-card-subtitle>

                        <v-card-text class="pb-0"
                          v-if="question.question_type == 'single-select'"
                        >
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-radio-group class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                  @change="checkifAnswered()"
                              >
                                <v-radio
                                  v-for="(
                                    answer, answerindex
                                  ) of question.answers"
                                  :key="answerindex"
                                  :value="answer.answer_id"
                                  :label="`${answer.answer_text}`"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text class="pb-0" v-else>
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-checkbox class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                v-for="(
                                  answer, answerindex
                                ) of question.answers"
                                :key="answerindex"
                                :value="answer.answer_id"
                                :label="`${answer.answer_text}`"
                                @change="checkifAnswered()"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>

              <v-card
                class="mx-auto mt-2 footer-buttons"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="submitTestExams"
                  :disabled="!answeredAllQuestions"
                >
                  {{ "Submit" | translate }}
                </v-btn>

                <v-btn
                  text
                  @click="quitTest()"
                >
                  {{ "Quit" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-card
                  class="mx-auto result-box"
                  max-width="530"
                  elevation="0"
                >
                  <v-row>
                    <v-col>
                      <div>
                        <h2 class="text-center text-uppercase">
                          {{ "Result" | translate }}
                        </h2>

                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-if="testExamResults.is_passed"
                        >
                          <v-icon large color="green darken-2" class="mr-2">mdi-checkbox-marked-circle</v-icon>
                          <span v-if="previousTestExamResults.length==1"> {{ testExam.test_message_1 | translate }}</span>
                          <span v-else> {{ testExam.test_message_3 | translate }}</span>
                          </v-card-text
                        >
                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-else
                        >
                          <v-icon large color="orange darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
                          {{ testExam.test_message_2 | translate }}
                          </v-card-text
                        >

                        <v-row class="result-percentage">
                          <v-col cols="12" md="6" sm="12">
                            <v-card-text class="text-center">{{ "You scored" | translate }} {{ testExamResults.scored_percentage }}%</v-card-text>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-card-text class="text-center">{{ "Percent of passing is" | translate }} {{ testExamResults.passing_percentage }}%</v-card-text>
                          </v-col>
                        </v-row>

                        <v-row class="ma-3" v-if="previousTestExamResults.length">
                          <v-col cols="12">
                            <div>
                              <v-divider></v-divider>
                              <DataTable
                                :title="testExam.module_id? 'Test History' : 'Exam History' | translate"
                                :headers="testExam.module_id? testheaders : examheaders"
                                :items="previousTestExamResults"
                              />
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  text
                  @click="
                    testExamDialog = false;
                    stage = 1;
                  "
                >
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <v-card v-else>
        <v-card-title>
          {{ "There is no Data to show" | translate }}
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="testExamDialog = false"
            >{{ "Close" | translate }}</v-btn
          ></v-card-title
        >
      </v-card>
    
     <v-overlay :value="isTestLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    </v-dialog>

    <v-dialog v-if="exerciseDialog" v-model="exerciseDialog" persistent>
      <v-card v-if="exercise.exercise_id" class="test-container">
        <v-stepper v-model="stage">
          <v-stepper-header>
            <v-stepper-step :complete="stage > 1" step="1">
              {{ "Instructions" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stage > 2" step="2">
              {{"Exercise"| translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              {{ "Results" | translate }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
            <v-stepper-content step="1">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-row class="ma-3">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="9" sm="12">
                        <v-card-title
                          class="text-h5"
                          v-text="exercise.exercise_name"
                        ></v-card-title>
                        <v-card-subtitle
                          v-text="exercise.exercise_description"
                        ></v-card-subtitle>
                      </v-col>
                      <v-col cols="12" md="3" sm="12">
                        <v-avatar class="grey" size="125" tile>
                          <v-img
                            v-if="exercise.exercise_image"
                            :src="storage_url + exercise.exercise_image"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-3">
                  <v-col>
                    <div>
                      <v-card-subtitle>
                        <div class="mb-n3">
                          <p v-html="exercise.first_page_details"></p>
                        </div>
                      </v-card-subtitle>
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="startExerciseStage2"
                >
                  {{ "Start" | translate }}</v-btn
                >

                <v-btn text @click="exerciseDialog = false">
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto pa-5"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >

              <v-card-title
                class="text-h5"
                v-text="exercise.exercise_name"
              ></v-card-title>
              <v-card-subtitle
                v-text="exercise.exercise_description"
              ></v-card-subtitle>
              
              <v-card-subtitle v-if="this.exerciseResultStatus=='uploaded'" style="color: #ffa500;">
               {{ exerciseMessage }}
              </v-card-subtitle>
                      
              <v-card-subtitle>
                <div class="mb-n3">
                  <p v-html="exercise.middle_page_details"></p>
                </div>

                <div id="download-container">
                  <v-btn
                    class="white--text mt-n1"
                    :color="primary_color"
                    @click=getDownloadLink(exercise);
                  >
                    {{ "Download Exercise" | translate }}</v-btn
                  >
                </div>

                <div class="upload-exercise-container" v-if="this.exerciseResultStatus!='uploaded'">
                  <v-form id="modelform" ref="modelform">
                      <v-file-input
                        id="resource_image"
                        name="filename"
                        class="mt-6"
                        v-model="resource_image_link"
                        outlined
                        chips
                        required
                        :rules="documentRules"
                        accept="image/*,.pdf"
                        :label="'Upload Exercise Answer' | translate"
                        @change="onFileSelected"
                      >
                        <template #message="{ message }">
                        {{
                            curLanguage.lang_code == "en"
                            ? message
                            : $t(message)
                        }}
                        </template>
                      </v-file-input>
                  </v-form>
                </div>

              </v-card-subtitle>

              </v-card>

              <v-card
                class="mx-auto mt-2 footer-buttons"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="submitExercise"
                  :disabled="!answeredExercise"
                  v-if="this.exerciseResultStatus!='uploaded'"
                >
                  {{ "Submit" | translate }}
                </v-btn>

                <v-btn text @click="exerciseDialog = false;
                stage = 1;">
                  {{ "Close & come back later" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-card
                  class="mx-auto result-box"
                  elevation="0"
                >
                  <v-row>
                    <v-col>
                      <div>
                        <h2 class="text-center text-uppercase">
                          {{ "Result" | translate }}
                        </h2>

                        <v-card-subtitle v-if="this.exerciseResultStatus=='uploaded'">
                          <div class="mb-n3">
                            <p v-html="exercise.instruction_on_upload"></p>
                          </div>
                        </v-card-subtitle>

                        <v-card-subtitle v-if="this.exerciseResultStatus=='complete'" style="color: #008000;">
                          <div class="mb-n3">
                            <p v-html="exercise.instruction_on_grade"></p>
                          </div>
                        </v-card-subtitle>

                        <v-card-subtitle>
                          <div class="mb-n3">
                            <p v-html="exercise.last_page_details"></p>
                          </div>
                        </v-card-subtitle>
                        
                    
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  text
                  @click="
                    exerciseDialog = false;
                    stage = 1;
                  "
                >
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
 
    
     <v-overlay :value="isTestLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    </v-dialog>

      <v-dialog v-if="message" v-model="message" persistent>
          <v-card>
                <v-card-title>
                  {{ message | translate }}
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary darken-1"
                    text
                    @click="message = false"
                    >{{ "Close" | translate }}</v-btn
                  ></v-card-title
                >
              </v-card>
      </v-dialog>

      <v-dialog v-model="feedbackDialog" persistent max-width="560">
        <v-card>
          <v-card-title class="headline">{{ feedbackMessage| translate }}</v-card-title>
          <v-card-subtitle class="headline">{{ feedbackMessageDescription| translate }}</v-card-subtitle>
          <v-card-text>
          <span v-if="feedbackMessage=='You already passed test!'">
            {{ "If you want to check your test history, Click here" | translate}}
            <v-btn small class="ml-6 white--text" :color="primary_color" :to="'/test-center'" >{{ 'Jump to Test Center'| translate }}</v-btn>
          </span>
        </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="feedbackDialog = false">{{ 'Close'| translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-if="testResultDialog" v-model="testResultDialog" persistent>
        <v-card>
          <h2 class="text-center text-uppercase">
            {{ "Result" | translate }}
              <v-btn color="primary darken-1" style="float:right" text v-on:click="closeTestExamResultDialog()">{{ 'Close'| translate }}</v-btn>
          </h2>
          <v-row>
            <v-col></v-col>
            <v-col cols="6">
              <ViewTestExamDetails
                :testResults="testResults"
              />
            </v-col>
            <v-col></v-col>
          </v-row>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text v-on:click="closeTestExamResultDialog()">{{ 'Close'| translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-if="exerciseResultDialog" v-model="exerciseResultDialog" persistent>
        <v-card>
          <h2 class="text-center text-uppercase">
            {{ "Result" | translate }}
              <v-btn color="primary darken-1" style="float:right" text v-on:click="closeExerciseResultDialog()">{{ 'Close'| translate }}</v-btn>
          </h2>
          <v-row>
            <v-col></v-col>
            <v-col cols="6">

              <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="text-h5">
                  {{ exercise.exercise_name }}sss
                </v-card-title>

                <v-card-subtitle> {{ exercise.exercise_description }}</v-card-subtitle>

                <v-card-actions>
                  <div id="download-container">
                  <v-btn
                    class="mt-4"
                    :color="primary_color"
                    @click=getDownloadLink2(exercise);
                    outlined
                    rounded
                    small
                  >
                    {{ "Download Exercise Question" | translate }}</v-btn
                  >
                </div>
                </v-card-actions>
              </div>

              <v-img
                  v-if="exercise.exercise_image"
                  :src="storage_url + exercise.exercise_image"
                  height="200px"
              ></v-img>
            </div>

              <v-card-subtitle>

                <div>

                  <v-data-table
                    v-if='exercise.exercise_files'
                    :headers="exerciseAnswerHeaders" :items="exercise.exercise_files"
                  >
                  <template v-slot:top>
                    <v-card-title>
                      {{  'Uploaded Answers' | translate }} 
                      <v-spacer></v-spacer>
                    </v-card-title>
                    </template>
                    <template slot="no-data">
                        {{ 'No data available' | translate }}
                    </template>
                    
                    <template v-slot:item="{ item }">
                          <tr style="cursor:pointer;">
                            <td>{{ item.id }}</td>
                            <td>{{ item.created_at }}</td>
                            <td>{{ item.graded_at ? item.graded_at : '-' }}</td>
                            <td>{{ item.evaluated_by ? item.evaluated_by.name : '-' }}</td>
                            <td>{{ item.evaluated_by ? item.evaluated_by.email : '-' }}</td>
                            <td>{{ item.comment?item.comment:'No comments added' | translate}}</td>
                            <td>{{ item.grade?item.grade:"Not yet graded" | translate }}</td>
                            <td> 
                              <v-btn small class="mt-2" target="_blank" color="primary" @click="getUploadedExerciseAnswer(exercise, item)"><v-icon>mdi-download</v-icon></v-btn>
                            </td>
                          </tr>
                      </template>

                    <template v-slot:footer.page-text="items"> 
                      {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                    </template>
                  </v-data-table>
                  
                </div>

                </v-card-subtitle>

            </v-col>
            <v-col></v-col>
          </v-row>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text v-on:click="closeExerciseResultDialog()">{{ 'Close'| translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay> 
</v-content>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store"
import {
  FETCH_COMPANY_SETTINGS,
  FETCH_DAILY_QUIZ,
  FETCH_OPEN_QUIZZES,
  FETCH_INDIVIDUAL_QUIZ,
  FETCH_QUESTION,
  ADD_DAILY_USER_ANSWERS,
  ADD_USER_ANSWERS,
  FETCH_DAILY_USER_ANSWERS,
  FETCH_TEST_EXAM,
  FETCH_ALL_TESTS,
  FETCH_ALL_EXAMS,
  FETCH_DETAILED_INDIVIDUAL_TEST_RESULTS,
  FETCH_DETAILED_INDIVIDUAL_EXAM_RESULTS,
  FETCH_INDIVIDUAL_TEST_EXAM,
  ADD_TEST_EXAM_USER_ANSWERS,
  // FETCH_ALL_EXERCISES,
  FETCH_ALL_AVAILABLE_EXERCISES,
  FETCH_INDIVIDUAL_EXERCISE,
  DOWNLOAD_EXERCISE_TEMPLATE,
  FETCH_USER_UPLOADED_EXERCISE_ANSWERS,
  ADD_EXERCISE_USER_ANSWERS,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER,SET_SNACKBAR } from "@/store/mutations.type"
export default {
  name: "Quiz",
  async beforeRouteEnter(to, from, next) {
    store.dispatch(RESET_STATE),
    await store.dispatch(FETCH_DAILY_USER_ANSWERS,""),
    await store.dispatch(FETCH_OPEN_QUIZZES, ""),
    await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile');
    return next();
  },
  beforeRouteLeave(to, from, next) {
    store.dispatch(RESET_STATE)
    next();
  },
  data: function() {
    return {
      title: "Test Center",
      search: "",
      dialogstatus: false,
      dialogButtontitle: null,
      dialogboxtitle: null,
      quiz_id: null,
      singleSelect: "",
      dialog: false,

      daily_quiz_question_count:'',
      daily_quiz_passing_percent:'',
      primary_color: '',
      moduleQuizDialog: false,
      stage: 1,
      moduleQuiz: [],
      questions: [],
      questionAnswers: [],
      quizResults: [],
      answeredAllQuestions: false,
      has_quiz:false,
      tabs:null,
      startTime:null,
      endTime:null,
      isLoading:false,
      openedTab:[],
      extquizdetaildata: [], 
      extquizdetailtitle: 'Quiz Score History',
      lockMessage:false,
      storage_url: "",
      is_daily_quiz:true,

      //Bar graph variables
      width: 2,
      radius: 10,
      lineCap: 'round',
      gradient: ['green', 'red'],
      graphvalue: [],
      graphlabels: [],
      gradientDirection: 'top',
      fill: true,
      type: 'trend',
      autoLineWidth: false,
      message:'',

      ///chartjs bar
      chartData: {
        labels: [],
        datasets: [
        ]
      },
      dailyQuizErrormessages: [
        {
          message: `Have you subscribed to Courses?`,
          step: '1',
        },
        {
          message: `Have you completed any modules in a course? Does that module have any quiz?`,
          step: '2',
        },
        {
          message: `Have you completed any Courses? Does that Course have any quiz?`,
          step: '3',
        },
        {
          message: `Has your company configured settings for Daily Quizzes?`,
          step: '4',
        },
      ],

      //tests
      allTests:[],
      allTestResults:[],
      testResultDialog: false,
      testResults:[],
      
      lastCourseId: null,
      examCourseId: null,
      testModuleId: null,
      testExam: [],
      testExamDialog: false,
      testExamMetaData:null,
      testExamResults: [],
      countertimer:null,
      previousTestExamResults: [], 
      isTestLoading:false,

      feedbackDialog: null,
      feedbackMessage: null,
      feedbackMessageDescription:null,

      //exams
      allExams:[],
      allExamResults:[],

      //exercises
      allExercises:[],
      allExerciseResultsMandatory:[],
      allExerciseResultsTraining:[],
      exerciseResultDialog : false,
      current_exercise_type: null,
      fileURL: null,
      exerciseDialog: false,
      resource_image_link: null,
      answeredExercise: false,

      documentRules: [
        v => !!v || 'Please upload document',
        v => (v && v.size > 0) || 'Please upload document',
      ],

    };
  },
  components: {
    Header: () => import("@/components/header/Header"),
    BarChart: () => import("@/components/charts/Bar"),
    DataTable: () => import("@/components/datatable/datatable"),
    ViewTestExamDetails: () => import("@/components/modal/ViewTestExamDetails"),
  },
  computed: {
    ...mapGetters(["quizzes",'currentUser','loadingdata','companysettings','useranswers']),
    headers () {
      return [
        { text: this.$t("Quiz id"), value: "quiz_id" },  
        { text: this.$t("Name"), value: "quiz_name" },        
        { text: this.$t("Description"), value: "quiz_description" },        
        { text: this.$t("Language"), value: "quiz_language" },        
        { text: this.$t("Actions"), value: "action", sortable: false }
      ]
    },
    testheaders () {
      return [
        { text: this.$t("Attempt"), value: "attempt" },  
        { text: this.$t("Test Taken on"), value: "created_at" },        
        { text: this.$t("Passing Percentage"), value: "passing_percentage" },        
        { text: this.$t("Scored Percentage"), value: "scored_percentage" },        
        { text: this.$t("Status"), value: "is_passed" },        
      ]
    },
    exerciseAnswerHeaders(){
      return [
        { text: this.$t("Id") },   
        { text: this.$t("Date taken")},   
        { text: this.$t("Date graded")},   
        { text: this.$t("Graded By")},   
        { text: this.$t("Examiner Email")},   
        { text: this.$t("Comment")},
        { text: this.$t("Grade") },
        { text: this.$t("File Uploaded")},
      ]
    },
  },
  created() {
    this.storage_url = process.env.VUE_APP_STORAGE_URL;
    this.company_storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
    
  },
  async mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color  = company_meta.primary_color
    if(company_meta.hasOwnProperty('has_quiz')){
      this.has_quiz = (company_meta.has_quiz==='true') //since returned value is a tring and not boolean
    }

    if(this.companysettings.hasOwnProperty('setting_data')){
        this.daily_quiz_question_count = this.companysettings.setting_data.daily_quiz_question_count
        this.daily_quiz_passing_percent = this.companysettings.setting_data.daily_quiz_passing_percent
    }

    let scoredata = [];
    this.useranswers.forEach((element) => {
      this.graphvalue.push(element.scored_percentage);
      let date = new Date(element.created_at);

      this.graphlabels.push(date.getDate()+'/'+date.getMonth());
      
      //Chart JS
      const month = ["Jan","Feb","March","April","May","June","July","Aug","Sept","Oct","Nov","Dec"];
      const options = { month: "short", day: "numeric" }

      let datetoconvert = element.created_at.replace(/-/g, '/').replace('T', ' ');
      let graphdate = new Date(datetoconvert);
      
      const quizdateString = graphdate.getDate() + ' ' + month[graphdate.getMonth()] + ' ' + graphdate.getFullYear();
      let quizdate = new Date(quizdateString).toLocaleDateString(this.currentUser.lang_code, options);

      this.chartData.labels.push(quizdate);
      scoredata.push(element.scored_percentage);
    });
    this.chartData.datasets.push({
      label: this.$t("Daily Quiz"),
      backgroundColor: this.primary_color,
      data: scoredata
    });

  },
  methods: {
    async startStage2(){
      this.startTime = new Date();
      this.stage = 2
    },
    async callDailyQuiz() {
      this.is_daily_quiz = true;
      this.isLoading = true;
      await store.commit(SET_LOADING, true);

      await store.dispatch(FETCH_DAILY_QUIZ, "").then((resp) => {
          if (resp.success) {
            store.commit(SET_LOADING, false);
            store.commit(SET_ROUTER_ENTER, false);
            //call quiz modal
              this.questions = resp.data;
              this.moduleQuizDialog = true;
              this.questionAnswers = [];
              this.answeredAllQuestions = false
              this.questions.forEach((element) => {
                this.questionAnswers.push({
                  question_id: element.question_id,
                  answer_id: [],
                });
              });
            this.isLoading = false;
          }
       
        })
        .catch(err => {
            this.message = err.message;
            this.message = "You have already taken the daily quiz" ;
        })
        
    },
    async callQuiz(quizId) {
      this.isLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_QUIZ, quizId).then((resp1) => {
        if (resp1.success) {
          this.moduleQuiz = resp1.data;
          this.extquizdetaildata=[];
        }
      });
      await store
        .dispatch(FETCH_QUESTION, "?quiz_id=" + quizId)
        .then((resp) => {
          if (resp.success) {
            store.commit(SET_LOADING, false);
            store.commit(SET_ROUTER_ENTER, false);
            //call quiz modal
            this.questions = resp.data;
            this.moduleQuizDialog = true;
            this.questionAnswers = [];
            this.answeredAllQuestions = false
            this.questions.forEach((element) => {
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_id: [],
              });
            });
            this.isLoading = false;
          }
        });
        
    },  
    async fetchAllOpenQuizzes(){
        this.is_daily_quiz = false;
        this.isLoading = true;
        await store.dispatch(FETCH_OPEN_QUIZZES, "").then((resp) => {
          if (resp.success) {
            this.isLoading = false;
          }
        }).catch(err => {
            this.message = err.message;
            this.isLoading = false;
        });
    },
    async callExam(courseId) {
        this.isTestLoading = true;
        await store.commit(SET_LOADING, true);
        await store.dispatch(FETCH_INDIVIDUAL_TEST_EXAM,courseId+'?include_questions=false&type=exam').then((resp1) => {
          if (resp1.success) {
              this.lastCourseId = courseId;
              this.testExam = resp1.data;
              this.totalTestTime = (resp1.data.time_limit_in_minutes);
              this.isTestLoading = false;
              this.testExamDialog = true;
              this.$store.commit(SET_LOADING, false)
          }
          else{
            this.feedbackMessage="Exam not found for this module. Please contact Administrator."; //might never reach here
            this.feedbackDialog=true;
          }
        })
        .catch(err => {
            this.feedbackMessage = err.response.data.message;
            this.feedbackDialog=true;
        });

    },
    async callTest(courseId,moduleId) {
      this.isTestLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_TEST_EXAM, moduleId + '?course_id='+courseId+'&include_questions=false&type=test').then((resp1) => {
        if (resp1.success) {
            this.lastCourseId = courseId;
            this.testExam = resp1.data;
            this.totalTestTime = (resp1.data.time_limit_in_minutes);
            if(moduleId){
              this.testModuleId = moduleId;
            }
            this.isTestLoading = false;
            this.testExamDialog = true;
            this.$store.commit(SET_LOADING, false)
        }
        else{
          this.feedbackMessage="Test not found for this module. Please contact Administrator."; //might never reach here
          this.feedbackDialog=true;
        }
      })
      .catch(err => {
          this.feedbackMessage = err.response.data.message;
          this.feedbackDialog=true;
      });
    },
    async callExercise(courseId,exercise,exercise_type) {
      this.isTestLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_EXERCISE,exercise.exercise_id+'?course_id='+courseId+'&exercise_type='+exercise_type).then((resp1) => {
        if (resp1.success) {
            this.lastCourseId = courseId;
            this.exercise = resp1.data;
            this.exercise.exercise_type = exercise_type;
            this.exerciseResultStatus= resp1.data.status;
            this.exerciseResults= resp1.status;
            this.isTestLoading = false;
            this.exerciseDialog = true;
            this.$store.commit(SET_LOADING, false)
        }
      })
      .catch(err => {
          this.feedbackMessage = err.response.data.message;
          this.feedbackDialog=true;
      });
    },
    async startExerciseStage2(){
      if(this.exerciseResultStatus=='uploaded' || this.exerciseResultStatus=='complete'){
        this.stage = 3
        return;
      }
      this.startTime = new Date();
      this.stage = 2
    },
    onFileSelected() {
        this.resource_image_link = document.getElementById("resource_image").files[0];
        this.exercise_resource_url = URL.createObjectURL(this.resource_image_link);
        this.answeredExercise = true;
    },
    async startTestStage2(){
      this.isTestLoading = true;
      var tosendparams = '';
      if(this.testModuleId){
        tosendparams =  this.testModuleId + '?course_id='+this.lastCourseId+'&include_questions=true&type=test'
      }
      else{
        tosendparams =  this.lastCourseId+'?include_questions=true&type=exams'
      }
      await store.dispatch(FETCH_INDIVIDUAL_TEST_EXAM, tosendparams).then((resp1) => {
        if (resp1.success && resp1.data.questions) {
          this.startTime = new Date();
          this.countertimer = null; //Resetting timer if still on
          if(this.totalTestTime){
            this.startCountdown(this.totalTestTime);
          }
          this.questions = resp1.data.questions;
          this.questionAnswers = [] ;
          this.answeredAllQuestions = false
          this.questions.forEach((element) => {
            if(element.question_type=="text"){
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_text: [],
              });
            }
            else{
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_id: [],
              });
            }
          });
          this.isTestLoading = false;
          this.stage = 2
        }
        else{
          this.feedbackMessage="This Test is already taken.";
          this.feedbackDialog=true;
        }
      })
      .catch(err => {
          this.isTestLoading = false;
          this.testExamDialog = false;
          this.feedbackMessage = err.response.data.message;
          this.feedbackDialog=true;
      });
    },
    async submitTestExams() {
      this.isTestLoading = true;
      clearInterval(this.countertimer);  
      await store.commit(SET_LOADING, true)
      this.answeredAllQuestions = false
      this.endTime = new Date();
      var seconds = (this.endTime - this.startTime) / 1000;
      let meta_questionAnswers =  [];
      this.questions.forEach((element) => {
            let metaans = [];
            this.questionAnswers.forEach((ans) => {
              if(ans.question_id == element.question_id){
                if(element.question_type=="multiple-select"){
                  ans.answer_id.forEach((multians) => {
                    let tempqn = element.answers[element.answers.findIndex(o => o.answer_id == multians)];
                      metaans.push({
                          answer_id: multians,
                          answer_text: tempqn.answer_text,
                      })
                  });
                }
                if(element.question_type=="single-select"){
                let tempqn = element.answers[element.answers.findIndex(o => o.answer_id == ans.answer_id)];
                  metaans.push({
                      answer_id: ans.answer_id,
                      answer_text: tempqn.answer_text,
                  })
                }
              }
           
            });
          
            if(element.question_type=="text"){
              meta_questionAnswers.push({
                question_id: element.question_id,
                question_name: element.question_name,
                question_type: element.question_type,
                question_text: element.question_text,
                answers: metaans,
              });
            }
            else{
              meta_questionAnswers.push({
                question_id: element.question_id,
                question_name: element.question_name,
                question_type: element.question_type,
                question_text: element.question_text,
                answers: metaans,
              });
            }
      });
         
      let params={
          "test_id": this.testExam.test_id,
          "course_id": this.lastCourseId,
          "seconds":seconds,
          "question_answer":this.questionAnswers,
        }
        

      if(this.testModuleId){
        params['module_id']= this.testModuleId;
      }

      await store
        .dispatch(ADD_TEST_EXAM_USER_ANSWERS, params )
        .then((resp) => {
          if (resp != undefined && resp.success) {
            if(this.testModuleId){
              this.$store.commit(SET_SNACKBAR, {status: true, message: "Test was submitted successfully!"});
            }
            else{
              this.$store.commit(SET_SNACKBAR, {status: true, message: "Exam was submitted successfully!"});
            }
            if(resp.data){
              this.previousTestExamResults = resp.data;
              this.testExamResults = this.filterObjectsByHighestAttempt(resp.data);
            }
            this.stage = 3
            this.$store.commit(SET_LOADING, false)
            this.isTestLoading = false;
            this.testExamDialog = true;
          }
        }) 
        .catch(err => {
            this.isTestLoading = false;
            this.testExamDialog = false;
            this.feedbackMessage = err.response.data.message;
            this.feedbackDialog=true;
        });
      return;
    },
    async submitExercise() {
      this.isTestLoading = true;
      await store.commit(SET_LOADING, true)
      this.answeredAllQuestions = false
      this.endTime = new Date();
      var seconds = (this.endTime - this.startTime) / 1000;
         
      var formData = new FormData(document.getElementById("modelform"));

      formData.set("exercise_id", this.exercise.exercise_id)
      formData.set("course_id", this.lastCourseId)
      formData.set("exercise_type", this.exercise.exercise_type)
      formData.set("exercise_file", this.resource_image_link);
      formData.set("seconds", seconds)

      await store
        .dispatch(ADD_EXERCISE_USER_ANSWERS, formData )
        .then((resp) => {
          if (resp != undefined && resp.success) {
              this.$store.commit(SET_SNACKBAR, {status: true, message: "Exercise was submitted successfully!"});
            this.stage = 3
            this.exerciseResultStatus = 'uploaded';
            this.$store.commit(SET_LOADING, false)
            this.isTestLoading = false;
            this.exerciseDialog = true;
          }
        }) 
        .catch(err => {
            this.isTestLoading = false;
            this.exerciseDialog = false;
            this.feedbackMessage = err.response.data.message;
            this.feedbackDialog=true;
        });
      return;
    },
    startCountdown(minutes) {
      var seconds = minutes * 60; // Convert minutes to seconds
      var timer = setInterval(function() {
        // Calculate remaining minutes and seconds
        var remaininghours = Math.floor(seconds / 3600);
        var remainingMinutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;

        // Display the countdown timer
        var formattedTime =
            remaininghours.toString().padStart(2, "0") +
            ":" +
            remainingMinutes.toString().padStart(2, "0") +
            ":" +
            remainingSeconds.toString().padStart(2, "0");
        document.getElementById("timer").textContent = formattedTime;

        // Decrement the timer by one second
        seconds--;
        this.timeelapsed = seconds;

        // Check if the timer has reached zero
        if (seconds < 0) {
          clearInterval(timer); // Stop the timer
        }
      }, 1000); // Update the timer every second (1000 milliseconds)

      this.countertimer = timer;

    },
    quitTest(){
      clearInterval(this.countertimer);  
      this.testExamDialog = false;
      this.stage = 1;
    },
    async fetchAllTests(){
      this.isLoading = true;
      await store.dispatch(FETCH_ALL_TESTS).then((resp) => {
          if (resp.success && resp.data) {
            this.allTests = resp.data;
          }
       })
       .catch(err => {
          this.message = err.message;
      });

      await store.dispatch(FETCH_TEST_EXAM,"?type=test").then((resp) => { //type=test is used to save data in module.js
          if (resp.success && resp.data) {
            this.allTestResults = resp.data;
          }
       })
       .catch(err => {
          this.message = err.message;
      });
       this.isLoading = false;
    },
    async fetchAllExams(){
      this.isLoading = true;
      await store.dispatch(FETCH_ALL_EXAMS).then((resp) => {
          if (resp.success && resp.data) {
            this.allExams = resp.data;
          }
       }).catch(err => {
          this.message = err.message;
      });

      await store.dispatch(FETCH_TEST_EXAM,"?type=exam").then((resp) => { //type=exam is used to save data in module.js
          if (resp.success && resp.data) {
            this.allExamResults = resp.data;
          }
       }).catch(err => {
          this.message = err.message;
      });
       this.isLoading = false;
    },
    async fetchAllExercises(){
      this.isLoading = true;

      await store.dispatch(FETCH_ALL_AVAILABLE_EXERCISES).then((resp1) => {
          if (resp1.success && resp1.data) {
            this.allExercises = resp1.data;
          }
       }).catch(err => {
          this.message = err.message;
      });

      await store.dispatch(FETCH_ALL_AVAILABLE_EXERCISES,"?has_uploaded=true").then((resp) => {
          if (resp.success && resp.data) {
            this.allExerciseResultsMandatory =(resp.data).mandatory_exercises;
            this.allExerciseResultsTraining =(resp.data).training_exercises;
          }
       }).catch(err => {
          this.message = err.message;
      });

       this.isLoading = false;
    },
    checkifAnswered(){
        const withNull = this.questionAnswers.filter(v => v.answer_id=="");  
        if(withNull.length==0){
            this.answeredAllQuestions = true
        }
        else{
            this.answeredAllQuestions = false
        }
    },
    async submitAnswers() {
      this.endTime = new Date();
      var seconds = (this.endTime - this.startTime) / 1000;
      let params={
        quiz_id:this.moduleQuiz.quiz_id,
        "seconds":seconds,
        "question_answer":this.questionAnswers
      }
      let api = '';
      if(this.is_daily_quiz){
        api = ADD_DAILY_USER_ANSWERS;
      }
      else{
        api =  ADD_USER_ANSWERS;
        if(this.moduleQuiz.quiz_type=="module"){
          params['module_id']= this.moduleQuiz.modules[0]
        }
        else{
          params['course_id']= this.moduleQuiz.course_id
        }
      }

      await store
        .dispatch(api, params )
        .then((resp) => {
          if (resp != undefined && resp.success) {
            this.quizResults = resp.data;
            this.stage = 3
            this.$store.commit(SET_LOADING, false)
            this.moduleQuizDialog = true;
          } else {
            this.callQuiz(this.moduleQuiz.quiz_id);
          }
        });

      return;
    },
    async getTestResults(testId, attempt){
      this.isLoading = true;
      await store.dispatch(FETCH_DETAILED_INDIVIDUAL_TEST_RESULTS,"?test_id="+testId+"&attempt="+attempt).then((resp) => {
          if (resp.success && resp.data) {
            this.testResults = resp.data;
            this.isLoading = false;
            this.testResultDialog = true;
          }
       });
    },
    async getExamResults(testId, attempt){
      this.isLoading = true;
      await store.dispatch(FETCH_DETAILED_INDIVIDUAL_EXAM_RESULTS,"?test_id="+testId+"&attempt="+attempt).then((resp) => {
          if (resp.success && resp.data) {
            this.testResults = resp.data;
            this.isLoading = false;
            this.testResultDialog = true;
          }
       });
    },
    closeTestExamResultDialog(){
      this.testResultDialog = false
    },
    async getExerciseResults(exercise, exercise_type){
      this.exercise = exercise;
      this.current_exercise_type = exercise_type;
      this.exerciseResultDialog = true;
    },
    closeExerciseResultDialog(){
      this.exerciseResultDialog = false
    },
    async getDownloadLink(exercise){
      this.$store.dispatch(DOWNLOAD_EXERCISE_TEMPLATE, 'view-file/'+exercise.exercise_id+'?course_id='+exercise.course_id+'&user_id='+store.state.auth.user.user_id+'&exercise_type='+exercise.exercise_type).then(async resp =>{
          if(resp != undefined && resp.hasOwnProperty('success') == false){
              this.fileURL = URL.createObjectURL(resp.data);                  
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', exercise.exercise_template);
              const container = document.getElementById("download-container"); // Change to the ID of your container
              container.appendChild(fileLink);
              fileLink.click(); 
              await this.$store.commit(SET_LOADING, false)     
          }
        })
    },
    async getDownloadLink2(exercise){
      this.$store.dispatch(DOWNLOAD_EXERCISE_TEMPLATE, 'view-file/'+exercise.exercise_id+'?exercise_type='+exercise.type+'&user_id='+exercise.user.user_id).then(async resp =>{
          if(resp != undefined && resp.hasOwnProperty('success') == false){
              this.fileURL = URL.createObjectURL(resp.data);                  
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', exercise.exercise_template);
              const container = document.getElementById("download-container"); // Change to the ID of your container
              container.appendChild(fileLink);
              fileLink.click(); 
              await this.$store.commit(SET_LOADING, false)     
          }
        })
    },
    async getUploadedExerciseAnswer(exercise, file){
      exercise.exercise_type='mandatory';
      await store.dispatch(FETCH_USER_UPLOADED_EXERCISE_ANSWERS,file.id+'?exercise_type='+exercise.exercise_type+'&user_id='+exercise.user.user_id).then(async resp => {
          if(resp != undefined && resp.hasOwnProperty('success') == false){
              this.fileURL = URL.createObjectURL(resp.data);                  
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', this.getLatestExerciseFile(exercise).exercise_file);
              const container = document.getElementById("download-container"); // Change to the ID of your container
              container.appendChild(fileLink);
              fileLink.click(); 
              await this.$store.commit(SET_LOADING, false)     
          }
        })
      
    },
    getLatestExerciseFile(exercise){
      const objectWithHighestId = exercise.exercise_files.reduce((maxObject, currentObject) => {
          if (!maxObject || currentObject.id > maxObject.id) {
            return currentObject;
          }
          return maxObject;
        }, null);

        return objectWithHighestId;
    },
    convertDate(dateString){
        const options = { year: "numeric", month: "long", day: "numeric" , hour: "numeric", minute: "numeric", second: "numeric",}
        return new Date(dateString).toLocaleDateString(this.currentUser.lang_code, options)
    },
    
  }
};
</script>

<style scoped>
.v-sparkline g {
    fill: rgba(135, 5, 5, 0.87) !important;
}

@media (max-width: 768px) {
  .bar-chart-btn .flexible-button {
    font-size: 12px;
  }
}

@media (max-width: 540px) {
  .bar-chart-btn .flexible-button {
    font-size: 7px;
  }
}


.timer{
  display: flex;
  justify-content: center;
} 

.sticky-container {
  position: sticky;
  top: 0;
  background-color: #fff; /* Customize as needed */
  z-index: 1; /* Ensure the sticky container is above the scrollable container */
  padding: 10px; /* Add padding as needed */
}

.scrollable-container {
  /* Add any desired styling for the scrollable container */
  max-height: 400px; /* Set a maximum height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrolling if content exceeds the container height */
}

.lockedoverlay{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  pointer-events: none;
  z-index: 99;
}
.locked {
      opacity: 0.7;
  }

</style>